const black = '#1a1a1a';
const white = '#ffffff';
const offWhite = '#f8f9fa';
/** Light seamless-studio gray that the 3D scenes render against. */
const studio = '#e4e4e4';
const blue = '#0066cc';
const success = '#16a34a';
const error = '#dc2626';
const warning = '#d97706';

const mix = (color: string, percent: number, other: string) =>
  `color-mix(in srgb, ${color} ${percent}%, ${other})`;

const color = {
  black,
  white,
  offWhite,
  studio,
  blue,
  raised: mix(white, 8, black),
  ink: mix(blue, 16, black),
  blueDeep: mix(black, 28, blue),
  blueBright: mix(white, 32, blue),
  blueMist: mix(white, 72, blue),
  blueSoft: mix(white, 92, blue),
  success,
  error,
  warning,
};

const alpha = {
  white: {
    4: mix(white, 4, 'transparent'),
    10: mix(white, 10, 'transparent'),
    15: mix(white, 15, 'transparent'),
    20: mix(white, 20, 'transparent'),
    30: mix(white, 30, 'transparent'),
    50: mix(white, 50, 'transparent'),
    60: mix(white, 60, 'transparent'),
    70: mix(white, 70, 'transparent'),
    80: mix(white, 80, 'transparent'),
    90: mix(white, 90, 'transparent'),
    95: mix(white, 95, 'transparent'),
  },
  black: {
    5: mix(black, 5, 'transparent'),
    8: mix(black, 8, 'transparent'),
    10: mix(black, 10, 'transparent'),
    12: mix(black, 12, 'transparent'),
    22: mix(black, 22, 'transparent'),
    35: mix(black, 35, 'transparent'),
  },
  blue: {
    10: mix(blue, 10, 'transparent'),
    12: mix(blue, 12, 'transparent'),
    15: mix(blue, 15, 'transparent'),
    20: mix(blue, 20, 'transparent'),
    25: mix(blue, 25, 'transparent'),
    32: mix(blue, 32, 'transparent'),
    45: mix(blue, 45, 'transparent'),
  },
  offWhite95: mix(offWhite, 95, 'transparent'),
  ink22: mix(color.ink, 22, 'transparent'),
};

export const palette = {
  color,
  alpha,
  gradient: {
    brand: `linear-gradient(135deg, ${blue} 0%, ${color.blueBright} 100%)`,
    brandHorizontal: `linear-gradient(90deg, ${blue} 0%, ${color.blueBright} 100%)`,
    textOnDark: `linear-gradient(90deg, ${color.blueMist} 0%, ${color.blueBright} 35%, ${mix(white, 55, blue)} 70%, ${color.blueMist} 100%)`,
    hero: `linear-gradient(135deg, ${black} 0%, ${color.ink} 42%, ${color.blueDeep} 100%)`,
    band: `linear-gradient(135deg, ${black} 0%, ${color.raised} 50%, ${blue} 100%)`,
    heroGlow: `radial-gradient(circle at 50% 50%, ${alpha.blue[20]} 0%, transparent 70%)`,
  },
};
